<template>
  <div class="customer-account-container">
    <!-- Header -->
    <AppHeader title="Customers Account Details" />
    
    <!-- Search and Filter Bar -->
    <div class="toolbar">
      <div class="search-box">
        <input 
          type="text" 
          v-model="searchQuery" 
          placeholder="Search customers..."
          @input="filterCustomers"
        >
        <i class="fas fa-search"></i>
      </div>
      <div class="filter-options">
        <select v-model="statusFilter" @change="filterCustomers">
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="suspended">Suspended</option>
        </select>
      </div>
    </div>

    <!-- Table Structure - Using paginatedCustomers instead of filteredCustomers -->
    <div class="table-responsive">
      <table id="customerAccountTable">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Address</th>
            <th>Registration Date</th>
            <th>Status</th>
            <th>Balance</th>
            <th>Operations</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(customer, index) in paginatedCustomers" :key="index">
            <td>{{ customer.name }}</td>
            <td>{{ customer.phone }}</td>
            <td>{{ formatAddress(customer) }}</td>
            <td>{{ formatDate(customer.registration_date) }}</td>
            <td :class="customer.isSuspend ? 'status-suspended' : 'status-active'">
              {{ customer.isSuspend ? 'Suspended' : 'Active' }}
            </td>
            <!-- <td :class="getBalanceClass(customer.balance)">
              {{ customer.balance }}
            </td> -->
            <td :class="getBalanceClass(customer.balance)">
  <div class="balance-control">
    <button class="balance-btn minus" @click="adjustBalance(customer, -1)">-</button>
    <input 
      type="number" 
      v-model.number="customer.balance" 
      @change="updateBalance(customer)"
      class="balance-input"
    >
    <button class="balance-btn plus" @click="adjustBalance(customer, 1)">+</button>
  </div>
</td>
            <td class="action-buttons">
              <button 
                class="btn-edit"
                @click="handleEdit(customer)"
                data-tooltip="Edit"
              >
                <img src="@/assets/edit_icon.png" alt="Edit">
              </button>
              <button 
                class="btn-invoice"
                @click="handleCreateInvoice(customer)"
                data-tooltip="Invoices"
              >
                <img style="filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(0deg);" src="@/assets/invoice.png" alt="Edit">
              </button>
              <button 
                class="btn-payment"
                @click="handleRecordPayment(customer)"
                data-tooltip="Record Payment"
              >
                <i style="filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(180deg);" class="fas fa-hand-holding-usd"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Empty State -->
    <div v-if="filteredCustomers.length === 0" class="empty-state">
      <i class="fas fa-users-slash"></i>
      <p>No customers found matching your criteria</p>
    </div>

    <!-- Pagination -->
    <div v-if="filteredCustomers.length > 0" class="pagination">
      <button 
        @click="prevPage" 
        :disabled="currentPage === 1"
        class="page-nav"
      >
        <i class="fas fa-chevron-left"></i>
      </button>
      <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
      <button 
        @click="nextPage" 
        :disabled="currentPage === totalPages"
        class="page-nav"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
      <select v-model="itemsPerPage" @change="resetPagination" class="page-size-select">
        <option value="5">5 per page</option>
        <option value="10">10 per page</option>
        <option value="20">20 per page</option>
        <option value="40">40 per page</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customers: [],
      filteredCustomers: [],
      searchQuery: '',
      statusFilter: 'all',
      currentPage: 1,
      itemsPerPage: 10,
      currentDate: "",
      currentTime: "",
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredCustomers.length / this.itemsPerPage);
    },
    paginatedCustomers() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredCustomers.slice(start, end);
    }
  },
  mounted() {
    this.updateDateTime();
    setInterval(this.updateDateTime, 1000);
    this.fetchCustomers();
  },
  methods: {
     adjustBalance(customer, direction) {
    // Create a copy to avoid directly modifying the original before API call
    const updatedCustomer = {...customer};
    updatedCustomer.balance = parseFloat(updatedCustomer.balance) + direction;
    this.updateBalance(updatedCustomer);
  },

  async updateBalance(customer) {
  try {
    this.$root.isLoading = true;
    const token = localStorage.getItem('authToken');
    
    const response = await fetch(`${this.$BASE_API_URL}/api/customers/edit_balance/${customer.id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        balance: parseFloat(customer.balance)
      })
    });

    const result = await response.json(); // Parse the JSON response
    
    if (!result.status) { // Now checking the status from the response body
      throw new Error(result.message || 'Failed to update balance');
    }
    const index = this.customers.findIndex(c => c.id === customer.id);
   if (index !== -1) {
  this.customers = [
    ...this.customers.slice(0, index),
    { ...customer },
    ...this.customers.slice(index + 1)
  ];
  this.filterCustomers();
}

    this.$toast.success(result.message || 'Balance updated successfully');
  } catch (error) {
    console.error('Error updating balance:', error);
    this.$toast.error(error.message || 'Failed to update balance');
  } finally {
    this.$root.isLoading = false;
  }
},
    updateDateTime() {
      const now = new Date();
      this.currentDate = now.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      this.currentTime = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    async fetchCustomers() {
      try {
        this.$root.isLoading = true;
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${this.$BASE_API_URL}/api/customers/acc_customers`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch customers');
        }

        const { data } = await response.json();
        this.customers = data;
        this.filteredCustomers = [...data];
      } catch (error) {
        console.error('Error fetching customers:', error);
        this.$toast.error('Failed to load customer data');
      } finally {
        this.$root.isLoading = false;
      }
    },
    filterCustomers() {
      let filtered = this.customers.filter(customer => {
        const matchesSearch = customer.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                            customer.phone.includes(this.searchQuery) ||
                            customer.id.toString().includes(this.searchQuery);
        
        const matchesStatus = this.statusFilter === 'all' || 
                            (this.statusFilter === 'active' && !customer.isSuspend) ||
                            (this.statusFilter === 'suspended' && customer.isSuspend);
        
        return matchesSearch && matchesStatus;
      });
      
      this.filteredCustomers = filtered;
      this.resetPagination();
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },
    formatAddress(customer) {
      if (!customer) return 'N/A';
      return [customer.area, customer.street, customer.build, customer.flat, customer.floor]
        .filter(part => part)
        .join(' - ');
    },
    getBalanceClass(balance) {
      return balance < 0 ? 'negative-balance' : 
             balance > 0 ? 'positive-balance' : 'zero-balance';
    },
    handleEdit(customer) {
      this.$router.push({ 
        name: "EditAccComponent", 
        params: { customerId: customer.id } 
      });
    },
    handleCreateInvoice(customer) {
      this.$router.push({ 
        name: "ShowInvoiceComponent", 
        params: { id: customer.id } 
      });
    },
    handleRecordPayment(customer) {
      this.$router.push({ 
        name: "PaymentsComponent", 
        params: { customerId: customer.id },
      });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    resetPagination() {
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
/* Add this new style for the page size selector */
.page-size-select {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  margin-left: 15px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 1rem;
  margin: 15px 15px 0 15px;
}

.search-box {
  position: relative;
  flex-grow: 1;
  max-width: 400px;
}

.search-box input {
  width: 100%;
  padding: 10px 15px 10px 40px;
  border: 1px solid;
  border-radius: 6px;
  font-size: 14px;
}

.search-box i {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.filter-options select {
  padding: 10px 15px;
  border: 1px solid;
  border-radius: 6px;
  background-color: white;
  font-size: 14px;
}

th, td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.status-active {
  font-weight: 500;
}

.status-suspended {
  font-weight: 500;
}

.positive-balance {
  font-weight: 500;
}

.negative-balance {
  font-weight: 500;
}

.zero-balance {
  color: #6c757d;
}

.action-buttons {
  display: flex;
  gap: 8px;
  border-bottom: hidden;
  border-right: hidden;
}

.action-buttons button {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}
.balance-control {
  display: flex;
  align-items: center;
  gap: 5px;
}

.balance-input {
  width: 70px;
  padding: 5px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  color: #000;
  text-align: center;
}

.balance-btn {
  width: 25px;
  height: 25px;
  border: none;
  border-radius: 4px;
  background-color: #f8f9fa;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.balance-btn:hover {
  background-color: #e9ecef;
}

.balance-btn.plus {
  color: green;
}

.balance-btn.minus {
  color: red;
}

/* Make sure input doesn't show spin buttons */
.balance-input::-webkit-outer-spin-button,
.balance-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.balance-input {
  -moz-appearance: textfield;
}
.action-buttons button:hover {
  transform: scale(1.1);
}

.action-buttons button:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: -35px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
}

.btn-edit:hover {
  transform: scale(1.2);
  opacity: .8;
} 

.empty-state {
  text-align: center;
  padding: 40px;
  color: #6c757d;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 15px;
  opacity: 0.5;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 15px;
}

.page-nav {
  width: 36px;
  height: 36px;
  border: 1px solid #dee2e6;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.page-nav:hover:not(:disabled) {
  background-color: #f8f9fa;
}

.page-nav:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #6c757d;
}

@media (max-width: 768px) {
  .toolbar {
    flex-direction: column;
  }
  
  .search-box {
    max-width: 100%;
  }
  
  th, td {
    padding: 8px 10px;
    font-size: 14px;
  }
  
  .action-buttons {
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .action-buttons button {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }
  
  .pagination {
    flex-wrap: wrap;
  }
  
  .page-size-select {
    margin-left: 0;
    margin-top: 10px;
    width: 100%;
  }
}
</style>